import { apiConf } from 'commons'

export const request = async (options, parse = true) => {
  const response = await apiConf.superFetch(options)
  if (response.status !== 200) throw new Error(response.statusText)
  if (!parse) return response
  return response.json()
}
